// App entry — composes the page + Tweaks panel

const App = () => {
  const [tweaks, setTweak] = useTweaks(window.TWEAK_DEFAULTS);

  // Apply tweaks to root
  React.useEffect(() => {
    const root = document.documentElement;
    root.dataset.bg = tweaks.background;
    root.dataset.type = tweaks.typePairing;
    root.dataset.density = tweaks.density;

    const h = tweaks.primaryHue;
    root.style.setProperty('--primary', `oklch(0.45 0.18 ${h})`);
    root.style.setProperty('--primary-hover', `oklch(0.38 0.20 ${h})`);
    root.style.setProperty('--primary-soft', `oklch(0.94 0.04 ${h})`);
  }, [tweaks]);

  return (
    <>
      <Nav/>
      <Hero/>
      <ScreensSection/>
      <Features/>
      <Stats/>
      <Pricing/>
      <FAQ/>
      <CTA/>
      <Footer/>
      <LegalModal/>

      <TweaksPanel title="Tweaks">
        <TweakSection label="Färg" />
        <TweakSlider
          label="Primärfärg (hue)"
          value={tweaks.primaryHue}
          min={0} max={60} step={1}
          unit="°"
          onChange={(v) => setTweak('primaryHue', v)}
        />
        <div style={{display:'flex', gap:6, marginTop:2}}>
          {[8, 12, 18, 25, 35].map(h => (
            <button key={h} onClick={() => setTweak('primaryHue', h)}
              style={{
                width:24, height:24, borderRadius:5,
                border: tweaks.primaryHue === h ? '2px solid #15171A' : '1px solid rgba(0,0,0,0.15)',
                background:`oklch(0.36 0.09 ${h})`, cursor:'pointer', padding:0
              }}/>
          ))}
        </div>

        <TweakSection label="Bakgrund" />
        <TweakRadio
          label="Ton"
          value={tweaks.background}
          options={[
            {value:"cool", label:"Cool"},
            {value:"warm", label:"Warm"},
            {value:"paper", label:"Paper"},
          ]}
          onChange={(v) => setTweak('background', v)}
        />

        <TweakSection label="Typografi" />
        <TweakRadio
          label="Pairing"
          value={tweaks.typePairing}
          options={[
            {value:"grotesk", label:"Grotesk"},
            {value:"editorial", label:"Editorial"},
            {value:"plex", label:"Plex"},
          ]}
          onChange={(v) => setTweak('typePairing', v)}
        />

        <TweakSection label="Densitet" />
        <TweakRadio
          label="Spacing"
          value={tweaks.density}
          options={[
            {value:"compact", label:"Tight"},
            {value:"comfortable", label:"Default"},
            {value:"spacious", label:"Roomy"},
          ]}
          onChange={(v) => setTweak('density', v)}
        />
      </TweaksPanel>
    </>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<App/>);
